module.exports = __webpack_public_path__ + "static/media/champ.7ef7fe91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/forum/champ.svg
// module id = ./src/assets/media/forum/champ.svg
// module chunks = 16